
import TranResourcesApi from './src/Tranresources'
import MailList from './src/MailList'
import SendSmsApi from './src/SendSmsApi'

let apis = {
   TranResourcesApi,
   MailList,
   SendSmsApi
};

export default apis;
